import React from 'react'
import { NavLink } from 'react-router-dom'
import "../../style/global.css"

export function ItemsNavbar({ to, title, className, subItems }) {
    return (
        <li className="nav-item ">
            <NavLink
                to={to}
                exact={true}
                smooth="true"
                spy="true"
                className={className}
                activeClassName="isActive"
            >
                <span className="text-wrap" >{title}</span>
            </NavLink>
            {subItems && (
                <div className="menu_service">
                    <div className="menu__service--item">
                        <NavLink to="/servicios/proyectomano"
                            activeClassName='isActive'
                            exact
                            className='nl-link'
                        >
                            Proyecto Llave en mano
                        </NavLink>
                    </div>
                    <div className="menu__service--item">
                        <NavLink to="/servicios/mantenimiento"
                            activeClassName='isActive'
                            exact
                            className='nl-link'
                        >
                            Mantenimiento
                        </NavLink>
                    </div>
                    <div className="menu__service--item">
                        <NavLink to="/servicios/capacitacion"
                            activeClassName='isActive'
                            exact
                            className='nl-link'
                        >
                            Capacitación
                        </NavLink>
                    </div>
                    <div className="menu__service--item">
                        <NavLink to="/servicios/serviciosadicionales"
                            activeClassName='isActive'
                            exact
                            className='nl-link'
                        >
                            Servicios adicionales
                        </NavLink>
                    </div>
                </div>
            )}
        </li>
    )
}
